import * as React from 'react';
import { RootContext } from '../../../index';

export default class ExaminationCompleteView extends React.Component {
  static contextType = RootContext;

  render () {
    return (
      <div className="p-examination">
        <div className="p-examination--content">
          {this.context.formatSimple(this.context.t('ExaminationCompleteView.message'))}
        </div>
      </div>
    );
  }
}
